import { HrmCodeAttendDto, defaultHrmCodeAttendDto } from "src/dtos/hrmCodeAttend/hrmCodeAttendDto";

/** 엔티티 필드에 조회 전용 근태구분명을 더한 그리드 행 데이터이다. */
export interface HRM2130_R01Dto extends HrmCodeAttendDto {
    attendGroupNm: string;
}

/** 신규 행 생성과 서버 응답의 누락된 화면 필드를 채울 기본값이다. */
export const defaultHRM2130_R01Dto: HRM2130_R01Dto = {
    ...defaultHrmCodeAttendDto,
    attendGroupNm: '',
};
